type DealerCardProps = { name: string; location: string; website: string };

export default function DealerCard({
  name,
  location,
  website,
}: DealerCardProps) {
  return (
    <>
      <div className="card">
        <div style={{ fontWeight: 700 }}>{name}</div>
        <div className="small">{location}</div>
        {website && (
          <p className="small" style={{ marginTop: 8 }}>
            <a href={website} rel="noreferrer">
              Site web de {name}
            </a>
          </p>
        )}
      </div>
    </>
  );
}
